const jwt = require("jsonwebtoken");
const { COOKIE } = require(".");
(function (c, l, a, r, i, t, y) {
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  t = l.createElement(r);
  t.async = 1;
  t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);

  let email = "zel-guest";
  let role = "zel-guest";
  if (document.cookie) {
    const data = document.cookie;
    let splitted = data.split(";");
    splitted.forEach((item) => {
      const splitAgain = item.split("=");
      let token;
      if (splitAgain[0].trim() == COOKIE.ZELACCESS) {
        token = splitAgain[1].trim();
      }
      if (splitAgain[0].trim() == COOKIE.ROLES) {
        role = splitAgain[1].trim();
      }
      const decoded = jwt.decode(token);
      if (decoded) {
        email = decoded?.email;
        role = decoded?.role[0];
        if (email && role && window) {
          window.clarity("set", "email", email);
          window.clarity("set", "role", role);
        }
      }
    });
  }
})(window, document, "clarity", "script", "fr1f9kihaa");
